module.exports = __webpack_public_path__ + "./images/plus-white.svg?798790aaad6eae561316c4668ed21827";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus-white.svg
// module id = 9
// module chunks = 0